<template>
    <div>
        <div class="ar__steps">
        	<div class="ar__steps_items">
        		<!-- <div class="ar_step">
        			<div class="ar_order">
        				<span class="mew_order">1</span>
        			</div>
        			<div class="ar_content">
        				<span class="new_p" v-text="t.start_watching_tutorial_ar"></span>
                        <fs5-button
                            class="ar_btn"
                            :label="t.watch_video_tutorial"
                            :text-transform-type="'capitalize'"
                            @clicked="openMBTutorial()"
                            :btn-type="'primary'"
                        ></fs5-button>
        			</div>
        		</div> -->
        		<div class="ar_step">
        			<div class="ar_order">
        				<span class="mew_order">1</span>
        			</div>
        			<div class="ar_content">
                        <div style="display: inline-flex;">
        				    <span class="new_p" v-text="t.office2_share_landingpage_passo3_criar_lista + ' | '"></span>
                            <span class="p_intern" v-text="t.inside_mb_account"></span>
                        </div>
                        <fs5-button
                            class="ar_btn"
                            :label="t.login_to"
                            :text-transform-type="'capitalize'"
                            @clicked="openMB()"
                            :btn-type="'primary'"
                        ></fs5-button>
        			</div>
        		</div>
        		<div class="ar_step">
        			<div class="ar_order">
        				<span class="mew_order">2</span>
        			</div>
        			<div class="ar_content">
                        <span class="new_p" v-text="t.select_mb_list_option"></span>
                        <fs5-button
                            class="ar_btn"
                            :label="t.click_here"
                            :text-transform-type="'capitalize'"
                            @clicked="openModalConnectMailingbossList()"
                            :btn-type="'primary'"
                        ></fs5-button>
        			</div>
        		</div>
        	</div>
        </div>


        <div id="registerListMailingBossModal" class="modal inmodal fade modal-v5">
            <div class="modal-dialog">
                <div class="modal-content modal_content" v-show="processing">
					<div class="modal-header">
                        <button type="button" class="close" @click="closeModal" aria-hidden="true">&times;</button>
                    </div>
                    <p style="padding: 2rem" v-text="t.processing"></p>
                </div>
                <div class="modal-content modal_content" v-show="!processing">
                    <div class="modal_header">
                        <button type="button" class="close" @click="closeModal" aria-hidden="true">&times;</button>
                        <h4 class="modal_title">
                            {{t.funnel_tab_autoresponder}}
                        </h4>
                        <fs5-collapse-info :view="[t.maillingboss_setup, t.autoresponder_maillingboss_setup_helper]"></fs5-collapse-info>

                        <!-- <div class="subtitile_box">
                        <span class="modal_subtitle">
                            {{t.maillingboss_setup}}
                        </span>
                        </div> -->
                    </div>
                    <div class="form_structure">
                        <div class="ar_step">
                            <div class="ar_order">
                                <span class="mew_order">2</span>
                            </div>
                            <div class="ar_content">
                                <span class="new_p" v-text="t.select_mb_list_option"></span>
                            </div>
                        </div>
                        <form role="form">
                            <div class="modal-body">
                                <div class="form-group">
                                    <span class="modal_subtitle">{{ t.office2_autopilot_rede_register_list_label }}</span>
                                    <div class="input-group select2-bootstrap-prepend">
                                        <input type="text" name="id_list" class="form-control" required="required">
                                        <span class="input-group-btn">
                                            <button @click.prevent="getListMailingBoss()" type="button" class="btn btn-primary btn-refresh-list is-primary">
                                                <i class="fa fa-refresh"></i>
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer mb-footer">
                                <button  class="button__transparent btn is-primary" @click.prevent="openMBHome()" >
                                    {{ t.office2_share_landingpage_passo3_criar_lista }}
                                </button>
                                <button type="submit" @click.prevent="submitMaillingBossList()" class="button__transparent btn is-primary">{{ t.button_salvar }}</button>
                            </div>
                        </form>
                    </div>
<!--                    <div class="modal-header">-->
<!--                        <button type="button" class="close" @click="closeModal" aria-hidden="true">&times;</button>-->
<!--                        <h4 class="modal-title"> {{ t.office2_autopilot_rede_register_list_title }} </h4>-->
<!--                    </div>-->
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import qs from "qs";

export default {
    name: "index",
    props: ["phpprops", 'toggleMainModal'],
    data(){
        return {
            t: [],
            followup_option: null,
            processing: false,
            radioDisabled: false,
            langIsRtl: window.__env.langIsRtl
        }
    },

    mounted() {
		this.init()
    },

    methods: {
		init() {
			this.t = this.phpprops.translations;
        	this.followup_option = this.phpprops.data.dados_usuario_office.autoresponder_followup == null ? 1 : this.phpprops.data.dados_usuario_office.autoresponder_followup
		},
        async openModalConnectMailingbossList() {
			await this.getListMailingBoss();
			this.toggleMainModal();
			$('#registerListMailingBossModal').modal('show');
        },

        getListMailingBoss: function() {
            let vm = this;
            vm.processing = true;

            axios
                .get(this.phpprops.routes.rota_office_franchise_system_list_mb)
                .then(function(response) {
                    let sel_lists = $("input[name='id_list']", $('#registerListMailingBossModal'));
                    if (response.data.data.list_atual.id)
                        sel_lists.val(response.data.data.list_atual.id);

                    sel_lists.select2({
                        data: response.data.data.lists
                    });
                })
                .finally(function(){
                    vm.processing = false;
                });

        },

        submitMaillingBossList: function() {
            let vm = this;
            var sel_lists = $("input[name='id_list']", $('#registerListMailingBossModal'));
            vm.processing = true;

            axios
                .post(
                    vm.phpprops.routes.rota_office_franchise_system_list_mb,
                    qs.stringify({ id_list: sel_lists.val() })
                )
                .then(function(resposta) {
                    if (resposta.data.msg)
                        alertMsg(resposta.data.status, resposta.data.msg);
                    if (resposta.data.status == 'success'){
						$('#registerListMailingBossModal').modal('hide');
						vm.$emit('saveData')
					}
                })
                .finally(function(){
                    vm.processing = false;
                });
		},
		closeModal() {
			$('#registerListMailingBossModal').modal('hide');
			this.$emit('closeModal')
		},
        openMBTutorial() {
            window.open(this.phpprops.data.mb_tutorial_video, '_blank')
        },
        openMB() {
            window.open('https://office.builderall.com/us/office/mailingboss-v2', '_blank')
        },
        openMBHome() {
            window.open(this.phpprops.routes.rota_office_mailingboss_home, '_blank')
        }
	},
	watch: {
		phpprops: function(newVal, oldVal) {
			this.init()
		}
	}
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.ar__links {
	background: var(--theme-color-primary);
	border-radius: 4px;
	box-shadow: 0px 0px 1px #a7a5a5;
	padding-right: 1rem;
	margin: 1rem 0;
	.ar_link {
		display: flex;
		a {
			font-weight: bold;
			font-size: 0.85rem;
    		line-height: 1.4;
    		text-transform: uppercase;
			color: #fff;
			padding: 1.5rem;
			&:last-child {
				flex: 1;
				padding: 1.5rem 0;
			}
			span {
				text-transform: none;
				font-weight: normal;
			}
		}
		&:not(:last-child) {
			a:last-child {
				border-bottom: 1px solid #fff;
			}
		}
	}
}

.ar__steps {
    margin: 1rem 0;
	.ar_connect {
		padding: 3rem 0;
		text-align: center;
	}
}
.ar_step {
    color: #818A91;
    font-weight: bold;

    display: flex;
    align-items: center;

    border: 1px solid #C9E4FF;
    border-radius: 8px;

    margin: 0 0 2rem 0 !important;
    padding: 0 1rem;

    &:first-child {
        margin: .5rem 0 2rem 0 !important;
    }
    &:last-child {
        margin: 0 0 .5rem 0 !important;
    }
    div.ar_content {
        display: inline-flex;
        justify-content: space-between;
        padding: 1rem;
        &:first-child {
            width: 100px;
            display: flex;
            flex-direction: column;
            text-align: center;
            @media handheld, only screen and (max-width: 768px) {
                width: auto;
            }
            span.order {
                font-size: 1.5rem;
                color: #FFFFFF !important;
            }
            span.step {
                margin-top: 2px;
                font-size: .95rem;
            }
        }
        &:last-child {
            flex: 1;
            span.new_p {
                text-transform: uppercase;
                font-size: 1.05rem;

                font-family: 'Lato' !important;
                font-weight: 900;
                display: flex;
                align-items: center;

                color: #0080FC !important;
            }
            span.p_intern {
                font-family: 'Lato';
                font-weight: 900;
                font-size: 15px;

                display: flex;
                align-items: center;
                color: #A5B9D5;
            }
            .ar_btn {
                width: 20rem;
                height: 2.5rem;
            }
        }
    }
    .ar_order {
        width: 2.5rem !important;
        height: 2.5rem;
        border-radius: 50%;
        padding: 0 !important;
        background: #0080FC;

        display: flex;
        align-items: center;
        justify-content: center;
        .mew_order {
            font-size: 1.5rem;
            line-height: 1.5rem;
            color: #FFFFFF !important;
        }
    }
}
.modal_content {
    border: 1px solid #C9E4FF !important;
    border-radius: 8px !important;
    width: 100%;

    .modal_header {
        .modal_title {
            font-family: 'Lato';
            font-weight: bold;
            font-size: 29px;

            text-transform: uppercase;

            color: #A5B9D5;
        }

        .subtitile_box {
            padding: .5rem 1rem !important;
            width: 100% !important;
            background: #E9EDF2 !important;
            border-radius: 5px !important;

            .modal_subtitle {
                font-family: 'Lato';
                font-weight: bold;
                font-size: 15px;

                text-transform: uppercase;

                display: flex;
                align-items: center;

                color: #A5B9D5;
            }
        }
    }
}

.form_structure {
    margin: 3rem 0 1rem;
    border-radius: 8px;
    border: 1px solid #C9E4FF;

    .ar_step {
        min-height: 4rem;
        border: 0 !important;
        border-bottom: 1px solid #C9E4FF !important;
        border-radius: 0 !important;
    }

    .modal-body {
        display: flex;
        justify-content: center;

        .modal_subtitle {
            font-family: 'Lato';
            font-weight: bold;
            font-size: 15px;

            text-transform: uppercase;

            display: flex;
            align-items: center;

            color: #A5B9D5;

            margin-bottom: 1rem;
        }
    }


}



</style>



// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/share/autoresponder/index.vue